<template>
  <div class="s-homepage-statistics">
    <img
      alt="statistics background"
      class="s-homepage-statistics__background"
      :src="
        useCloudinary(tr('client.homepage.statistics_background_url'), {
          width: 1440,
          height: 'auto',
        })
      "
    />
    <SAppContainer>
      <SHeading
        class="s-homepage-statistics__title"
        color="white"
        level="2"
        size="2"
      >
        {{ tr("client.homepage.statistics_title") }}
      </SHeading>
      <div class="s-homepage-statistics__content">
        <div class="s-homepage-statistics__statistic">
          <p class="s-homepage-statistics__statistic-title">
            {{ tr("client.homepage.statistic_1_title") }}
          </p>
          <p class="s-homepage-statistics__statistic-description">
            {{ tr("client.homepage.statistic_1_text") }}
          </p>
        </div>
        <div class="s-homepage-statistics__divider" />
        <div class="s-homepage-statistics__statistic">
          <p class="s-homepage-statistics__statistic-title">
            {{ tr("client.homepage.statistic_2_title") }}
          </p>
          <p class="s-homepage-statistics__statistic-description">
            {{ tr("client.homepage.statistic_2_text") }}
          </p>
        </div>
        <div class="s-homepage-statistics__divider" />
        <div class="s-homepage-statistics__statistic">
          <p class="s-homepage-statistics__statistic-title">
            {{ tr("client.homepage.statistic_3_title") }}
          </p>
          <p class="s-homepage-statistics__statistic-description">
            {{ tr("client.homepage.statistic_3_text") }}
          </p>
        </div>
      </div>
    </SAppContainer>
  </div>
</template>

<script setup lang="ts">
import { useCloudinary } from "@solvari/common-fe/integrations";
import { SAppContainer, SHeading } from "@solvari/components";
import { useI18nMainSiteHomepage } from "@solvari/translations";

const { tr } = useI18nMainSiteHomepage();
</script>

<style lang="postcss">
.s-homepage-statistics {
  @apply relative h-screen-400;

  &__title {
    @apply relative m-0 pt-6 text-center;
  }

  &__content {
    @apply relative flex flex-col;
  }

  &__statistic {
    @apply py-6;

    &-title,
    &-description {
      @apply m-0 text-center text-white;
    }

    &-title {
      @apply pb-2 text-2xl font-bold;
    }

    &-description {
      @apply text-sm;
    }
  }

  &__divider {
    @apply mx-auto h-0.5 w-32 bg-accent-500;
  }

  &__background {
    @apply absolute h-full w-full object-cover transition-all;
    object-position: 65% 60%;
  }
}

@screen 700 {
  .s-homepage-statistics {
    @apply h-88;

    .s-app-container {
      @apply p-0;
    }

    &__title {
      @apply pt-16;
    }

    &__content {
      @apply mx-auto flex-row items-center pt-12;
    }

    &__statistic {
      @apply w-full px-8;

      &-title {
        @apply pb-4 text-4xl;
      }

      &-description {
        @apply text-lg;
      }
    }

    &__divider {
      @apply relative h-28 w-3;
    }
  }
}
</style>
